import { cn } from '@crehana/compass.ui/v2';
import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import { useAddI18nLocales, useChipTranslation } from "./i18n";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var chipVariants = /*#__PURE__*/cva('tw-group tw-flex tw-items-center tw-gap-x-0.8 tw-px-2 tw-py-1 tw-pt-0.8 tw-font-body3 tw-rounded-full tw-border tw-border-solid tw-transition-all tw-duration-200', {
  variants: {
    variant: {
      gray: /*#__PURE__*/cn('tw-bg-neutral-light-200 tw-border-neutral-light-400', 'hover:tw-text-primary-light-500 hover:tw-bg-gradient-to-r hover:tw-from-[#D6FD6A] hover:tw-to-neutral-light-100 hover:tw-shadow-01', 'active:tw-text-primary-light-500 active:tw-bg-gradient-to-r active:tw-from-[#D6FD6A] active:tw-to-neutral-light-100'),
      white: /*#__PURE__*/cn('tw-bg-white tw-border-neutral-light-400 tw-text-neutral-light-800', 'hover:tw-text-primary-light-500 hover:tw-bg-gradient-to-r hover:tw-from-[#D6FD6A] hover:tw-to-white hover:tw-shadow-01', 'active:tw-text-primary-light-500 active:tw-bg-gradient-to-r active:tw-from-[#D6FD6A] active:tw-to-white active:tw-border-primary-light-500')
    },
    isActive: {
      "true": '',
      "false": ''
    }
  },
  compoundVariants: [{
    variant: 'gray',
    isActive: true,
    "class": 'tw-text-primary-light-500 tw-bg-gradient-to-r tw-from-[#D6FD6A] tw-to-neutral-light-100'
  }, {
    variant: 'white',
    isActive: true,
    "class": 'tw-text-primary-light-500 tw-bg-gradient-to-r tw-from-[#D6FD6A] tw-to-white tw-border-primary-light-500'
  }]
});
export var HanaChip = function HanaChip(props) {
  var _p;
  var Icon = props.Icon,
    name = props.name,
    copilot_prompts = props.copilot_prompts,
    onClick = props.onClick,
    id = props.id,
    idActive = props.idActive,
    hasMoreCategories = props.hasMoreCategories,
    _props$asButton = props.asButton,
    asButton = _props$asButton === void 0 ? true : _props$asButton,
    _props$buttonVariant = props.buttonVariant,
    buttonVariant = _props$buttonVariant === void 0 ? 'gray' : _props$buttonVariant,
    className = props.className;
  useAddI18nLocales();
  var _useChipTranslation = useChipTranslation(),
    t = _useChipTranslation.t;
  var topicsCardContent = function topicsCardContent() {
    return /*#__PURE__*/_jsxs("div", {
      "aria-label": id,
      className: clsx(chipVariants({
        variant: buttonVariant,
        isActive: idActive === id
      }), className),
      children: [Icon, _p || (_p = /*#__PURE__*/_jsx("p", {
        className: "tw-font-body5 tw-mt-0.4",
        children: name
      }))]
    });
  };
  var isVisible = Boolean((copilot_prompts === null || copilot_prompts === void 0 ? void 0 : copilot_prompts.length) && (copilot_prompts === null || copilot_prompts === void 0 ? void 0 : copilot_prompts[0].template)) || hasMoreCategories;
  var renderContent = function renderContent() {
    if (isVisible && asButton) {
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onClick,
        "aria-label": t('LABEL_SELECT_CATEGORY', {
          interpolation: {
            name: name
          }
        }),
        children: topicsCardContent()
      });
    }
    if (isVisible) {
      return /*#__PURE__*/_jsx("div", {
        onClick: onClick,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.click();
          }
        },
        onKeyUp: function onKeyUp(e) {
          if (e.key === ' ') {
            e.preventDefault();
            e.currentTarget.click();
          }
        },
        role: "button",
        tabIndex: 0,
        "aria-label": t('LABEL_SELECT_CATEGORY', {
          interpolation: {
            name: name
          }
        }),
        children: topicsCardContent()
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: renderContent()
  });
};
export { chipVariants };